import React from "react";
import { Badge } from "reactstrap";

/**
 * How a settled forecast turned out, in the one form the whole site uses.
 *
 * The direction that was called, and whether it happened — not whether the
 * close landed inside the range. The lists used to show "In range" / "Missed",
 * computed in the browser from the range and the close, and that reads as a
 * grade while measuring something else: a band wide enough to cover every
 * plausible outcome lands "in range" without ever committing to a direction,
 * and a tight, correct call that fell a few cents short reads as "Missed".
 * The comparison table, the Blogger posts and the score itself all judge the
 * call; these were the last screens that did not.
 *
 * The verdict is computed on the server by memberScoreService and served with
 * the row. Deliberately not recomputed here: "right" also depends on how far
 * the model's own reported price sat from the real one, and a second
 * implementation in the browser would be a second answer.
 *
 * Three outcomes, and "no call" is genuinely one of them rather than a missing
 * value — most member forecasts centre their range close enough to the price
 * to be pointing nowhere, which is an honest answer and is scored as its own
 * band. Grey, because it is neither a success nor a failure.
 */
export const VerdictBadge = ({ verdict }) => {
  const styles = {
    right: { color: "success", text: "Right" },
    wrong: { color: "danger", text: "Wrong" },
    "no-call": { color: "light", text: "No call" },
  };
  const style = styles[verdict];
  if (!style) return null;
  return (
    <Badge
      color={style.color}
      className={`me-1${style.color === "light" ? " text-body" : ""}`}
      title={
        verdict === "right" ? "Called a direction, and it was the one that happened"
          : verdict === "wrong" ? "Called a direction, and it was not the one that happened"
            : "The range straddles the price it started from: no direction called"
      }
    >
      {style.text}
    </Badge>
  );
};

export default VerdictBadge;
